import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export function RoomAssignmentModal({ item, rooms, people, onPick, onClose }) {
  const [custom, setCustom] = useState("");
  const who = people.filter((p) => !/^(me|just me)$/i.test(p)).slice(0, 3).join(", ");
  return (
    <Dialog open={!!item} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="room-assignment-modal" className="max-w-md rounded-3xl p-0 overflow-hidden border-0">
        {item && (
          <div>
            <img src={item.url} alt={item.title} className="w-full h-44 object-cover" />
            <div className="p-7">
              <p className="eyebrow">Lovely pick · {item.title}</p>
              <h3 className="font-display text-3xl font-light mt-2 leading-tight">
                Whose room is this for?
              </h3>
              {who && <p className="text-sm text-neutral-500 mt-2">We remembered {who} will share this space — pick where it belongs.</p>}
              <div className="flex flex-wrap gap-2 mt-6">
                {rooms.map((r) => (
                  <button key={r} data-testid={`room-option-${r.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} onClick={() => onPick(r)} className="chip">
                    {r}
                  </button>
                ))}
              </div>
              <form
                className="mt-5 flex gap-2"
                onSubmit={(e) => { e.preventDefault(); custom.trim() && onPick(custom.trim()); }}
              >
                <input
                  data-testid="room-custom-input"
                  value={custom}
                  onChange={(e) => setCustom(e.target.value)}
                  placeholder="Somewhere else…"
                  className="flex-1 h-11 rounded-full border border-neutral-300 px-4 text-sm focus:outline-none focus:border-neutral-900"
                />
                <button data-testid="room-custom-submit" className="btn-ink h-11 px-5" disabled={!custom.trim()}>Add</button>
              </form>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
